export default "__VITE_ASSET__TbghZBZ6__"